<template>
  <bita-modal :id="modalId" :title="title" :modal-lg="true">
    <div slot="body">
      <p>لطفا حتما با رانندگان زیر تماس بگیرید و لغو شدن درخواست خود را اعلام بفرمایید مسئولیت عدم اطلاع رسانی بر عهده شما میباشد</p>
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>نام و نام خانوادگی</th>
            <th>شماره تماس</th>
            <th>نوع ماشین</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in propsData" :key="index">
            <td>{{ index+1 }}</td>
            <td>{{ item.driver.name }}</td>
            <td>{{ item.driver.user.phone }}</td>
            <td>{{ item.driver.vehicle_type.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    title: {},
    propsData: {
      type: Array,
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.onSubmit(this.dataView);
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      dataView: {},
    };
  },
  watch: {
    propsData: function (_data) {
      this.dataView = _data;
    },
  },
};
</script>
